import { useConnect as _useConnect } from "wagmi"
import { reservePopup, releaseReservedPopup } from "@privy-io/popup"

export const useConnect = () => {
  const { connectAsync: _connectAsync, connectors } = _useConnect()

  const connectAsync = async () => {
    if (connectors.length === 0) {
      throw new Error('Wallet not found')
    }

    reservePopup()

    try {
      await _connectAsync({ connector: connectors[0] })
    } catch (error) {
      throw error
    } finally {
      releaseReservedPopup()
    }
  }

  return { connectAsync }
}
